import React, { useEffect, useRef } from 'react';
import { useNotificationStatus } from './hooks/useNotificationStatus';
import { registerVapidSubscription } from './push/registerVapidSubscription';

export const PushSubscriber: React.FC = () => {
  const notificationStatus = useNotificationStatus();
  const inFlight = useRef(false);

  useEffect(() => {
    if (notificationStatus !== 'granted') {
      inFlight.current = false;
      return;
    }
    if (inFlight.current) return;
    inFlight.current = true;

    registerVapidSubscription()
      .catch((err) => {
        console.error('Auto subscription failed', err);
      })
      .finally(() => {
        inFlight.current = false;
      });
  }, [notificationStatus]);

  return null; // No visible output; runs the effect
};

export default PushSubscriber;
